import React, { useState } from 'react'
import CalendarCustom from './CalendarCustom'
import CalendarWeek from './CalendarWeek'
import CardEvents from './CardEvents'
import CardReminder from './CardReminder'
import Addevent from './Addevent'
import CreateEvent from './CreateEvent'

function BodyCalendar() {
    const [choice, setChoice] = useState('event')
    const [byDate, setByDate] = useState('month')
    const [addEvent, setaddEvent] = useState(false)
    const [createEvent, setcreateEvent] = useState(false)
    const [choiceEvent, setChoiceEvent] = useState('event')
    return (
        <>
            <div className="top-calendar-icon-sec">
                {
                    !createEvent && (
                        <div className="calendar-schedule" >
                            <div className="calendar-schedule-top" >
                                <span className="calendar-schedule-top-title" >Calendar</span>
                                <select value={byDate} onChange={(e) => setByDate(e.target.value)} >
                                    <option value='month' >By Month</option>
                                    <option value='week' >By Week</option>
                                </select>
                                <div style={{ position: "relative" }} >
                                    <span className="calendar-schedule-top-add" onClick={() => setaddEvent(true)} >Add</span>
                                    {
                                        addEvent && (
                                            <Addevent setChoiceEvent={setChoiceEvent} setaddEvent={setaddEvent} setcreateEvent={setcreateEvent} />
                                        )
                                    }
                                </div>
                            </div>
                            {
                                byDate == 'month' && (
                                    <CalendarCustom />
                                )
                            }
                            {
                                byDate == 'week' && (
                                    <CalendarWeek />
                                )
                            }
                            <div className="calendar-schedule-events" >
                                <span className={choice == "event" ? "active" : ""} onClick={() => setChoice('event')} >Event</span>
                                <span className={choice == "reminder" ? "active" : ""} onClick={() => setChoice('reminder')} >Reminder</span>
                            </div>
                            {
                                choice == "event" && (
                                    <div className="scroll-event" >
                                        <CardEvents backColor="#88D1E01A" init />
                                        <CardEvents backColor="#88D1E080" Accepted />
                                        <CardEvents backColor="#FF5D5B80" Declined />
                                        <CardEvents backColor="#1DB99E66" Invited />
                                    </div>
                                )
                            }
                            {
                                choice == "reminder" && (
                                    <div className="scroll-event" >
                                        <CardReminder />
                                        <CardReminder />
                                        <CardReminder />
                                    </div>
                                )
                            }
                            <br></br>
                        </div>
                    )
                }
                {
                    createEvent && (
                        <CreateEvent choiceEvent={choiceEvent} setChoiceEvent={setChoiceEvent} setcreateEvent={setcreateEvent} />
                    )
                }
            </div>
        </>
    );
}
export default BodyCalendar